import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { mensajeErrorCarga } from '../../core/http-errors';
import { ErrorFichaComponent } from '../error-ficha/error-ficha.component';
import { Component } from "@angular/core";
import { Asociacion, AsociacionesService, ResponseAsociaciones } from "../../../api";
import { CoreComponent } from "../core/core.component";
import { ItemType } from "../formulario/request.model";
import { SpinnerComponent } from "../spinner/spinner.component";

@Component({
  selector: 'app-asociaciones',
  standalone: true,
  imports: [CoreComponent, SpinnerComponent, ErrorFichaComponent],
  templateUrl: './asociaciones.component.html',
  styleUrl: './asociaciones.component.scss'
})
export class AsociacionesComponent {

  type: ItemType = ItemType.ASOCIACIONES;
  asociaciones: Asociacion[] = [];
  titleForm = 'Crear asociación';
  mode: 'list' | 'Crear' | 'Editar' | 'showItem' = 'list';
  loading: boolean = true;

  error = '';

  constructor(
    private router: Router,
    private asociacionesService: AsociacionesService
  ) { }

  ngOnInit() {
    this.error = '';
    this.loading = true;
    this.asociacionesService.asociacionesGet().subscribe({
      next: (res: ResponseAsociaciones) => {
        if (res.status?.status === 200) {
          this.asociaciones = res.asociaciones!;
          this.loading = false;
        } else {
          this.error = mensajeErrorCarga(undefined, 'el listado de asociaciones');
          this.loading = false;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.error = mensajeErrorCarga(err, 'el listado de asociaciones');
        this.loading = false;
      }
    });
  }

  irAInicio() {
    this.router.navigateByUrl('/home');
  }

}
